export default __webpack_public_path__ + "static/media/noa-33.9b9870c9.jpg";